import React from "react"
import PropTypes from "prop-types"

import StandardModal from '../../app_components/StandardModal';
import { withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';

const StyledSlider = withStyles({
  root: {
    color: 'rgba(3, 169, 244,.5)',
    height: 8,
  },
  thumb: {
    height: 18,
    width: 18,
    backgroundColor: '#03A9F4',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 4,
    borderRadius: 4,
  },
  rail: {
    height: 4,
    borderRadius: 4,
  },
})(Slider);

class AgeFilter extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      needAgeModal: false,
      min_age_difference: 18,
      max_age_difference: 152
    }
    this.needAgeModal = this.needAgeModal.bind(this)
    this.handleProPopup = this.handleProPopup.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    this.setState({
      min_age_difference: this.props.min_age_difference,
      max_age_difference: this.props.max_age_difference
    })
  }

  handleChange(event, value) {
    if (!this.props.premiumUser) {
      this.props.toggleProModal('filter')
    } else {
      this.props.updateAge(value[0], value[1])
    }
  }

  needAgeModal() {
    return(
      <StandardModal onClose={() => this.setState({needAgeModal: false})}>
        <h3 className="sectionText" style={{padding: 15}}>You need to save your age to use this filter.</h3>
        <button className="button_primary" onClick={() => window.location.replace('/edit')}>Go to my settings</button>
      </StandardModal>)
  }

  handleProPopup() {
    if(!this.props.premiumUser) {
      this.props.toggleProModal('filter')
    }
  }

  render() {
    return(
      <div onClick={() => this.handleProPopup()} className="filterSection">
        {this.state.needAgeModal && this.needAgeModal()}
        <div style={{display: 'flex', flexDirection: ''}}>
          <h4 className="sectionHeader">Age</h4>
          <h4 className="proHeader" style={{paddingLeft: 15}}>Pro Filter</h4>
        </div>
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <h4 className="greyText" style={{marginTop: 10, marginBottom: 10}}>Between {this.props.min_age_difference}-{this.props.max_age_difference}</h4>
          <div className="slider_container">
              <StyledSlider
                value={[this.props.min_age_difference, this.props.max_age_difference]}
                min={18}
                max={152}
                onChange={this.handleChange}
                valueLabelDisplay="off"
                aria-labelledby="range-slider"
              />
          </div>
        </div>
      </div>
    )
  }
}

export default AgeFilter;
